import * as React from 'react';
import type { SVGProps } from 'react';
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M6.86 2.774a.75.75 0 0 0-1.5 0v4.447a.75.75 0 1 0 1.5 0V5.748h4.808a.75.75 0 0 0 0-1.5H6.859V2.774ZM2.57 4.793c.349-.35.822-.545 1.316-.545a.75.75 0 1 1 0 1.5.36.36 0 0 0-.362.361v2.585h12.952V6.11a.36.36 0 0 0-.362-.361h-1.473V7.22a.75.75 0 0 1-1.5 0V2.774a.75.75 0 0 1 1.5 0v1.474h1.473a1.86 1.86 0 0 1 1.862 1.861v10.005a1.86 1.86 0 0 1-1.862 1.862H3.886a1.86 1.86 0 0 1-1.862-1.862V6.11c0-.493.196-.967.545-1.316Zm.954 11.321v-5.92h12.952v5.92a.36.36 0 0 1-.362.362H3.886a.36.36 0 0 1-.362-.362"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
